import { render, staticRenderFns } from "./VolumeConf.vue?vue&type=template&id=5bb7438f&scoped=true&"
import script from "./VolumeConf.vue?vue&type=script&lang=js&"
export * from "./VolumeConf.vue?vue&type=script&lang=js&"
import style0 from "./VolumeConf.vue?vue&type=style&index=0&id=5bb7438f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7438f",
  null
  
)

export default component.exports